/**
 * Données d'événement Clarity - accepte toute clé string avec des valeurs simples
 */
export interface ClarityEventData {
    [key: string]: string | number | boolean;
}

/**
 * Configuration pour initialiser Clarity
 */
export interface ClarityConfig {
    projectId: string;
    enabled: boolean;
    enableInDevelopment?: boolean;
    cookieConsent?: boolean;
    uploadUrl?: string;
    mask?: string[];
    unmask?: string[];
    regions?: string[];
}

/**
 * Informations utilisateur pour l'identification Clarity
 */
export interface ClarityUser {
    friendlyName: string;
    id: string;
    sessionId?: string;
    pageId?: string;
    userHint?: string;
}

/**
 * Types d'événements prédéfinis
 */
export enum ClarityEventType {
    CLICK = 'click',
    SCROLL = 'scroll',
    FORM_SUBMIT = 'form_submit',
    PAGE_VIEW = 'page_view',
    USER_LOGIN = 'user_login',
    USER_LOGOUT = 'user_logout',
    PURCHASE = 'purchase',
    SEARCH = 'search',
    ERROR = 'error',
    ERROR_SYMPLIFY = 'error_symplify',
    ERROR_SYMPLIFY_BY_SHOW = 'error_symplify_show',
    ERROR_SYMPLIFY_PRICE = 'error_symplify_price',
    CUSTOM = 'custom'
}

/**
 * Métriques de session Clarity
 */
export interface ClarityMetrics {
    sessionId: string;
    userId?: string;
    pageViews: number;
    events: number;
    errors: number;
    lastActivity: Date;
}

/**
 * Données de heatmap
 */
export interface ClarityHeatmapData {
    x: number;
    y: number;
    intensity: number;
}

/**
 * Informations de session complètes
 */
export interface ClaritySessionData {
    sessionId: string;
    duration: number;
    pages: string[];
    events: string[];
    userAgent: string;
}

/**
 * Statut de consentement RGPD
 */
export interface ConsentStatus {
    analytics: boolean;
    marketing: boolean;
    functional: boolean;
    necessary: boolean;
}

/**
 * Options pour le tracking d'événements e-commerce
 */
export interface ClarityEcommerceEvent extends ClarityEventData {
    product_id: string;
    category?: string;
    price?: number;
    currency?: string;
    quantity?: number;
}

/**
 * Options pour le tracking d'erreurs
 */
export interface ClarityErrorEvent extends ClarityEventData {
    error_message: string;
    error_stack?: string;
    context?: string;
    user_id?: string;
    timestamp?: number;
}

/**
 * Options pour le tracking de performance
 */
export interface ClarityPerformanceEvent extends ClarityEventData {
    load_time?: number;
    dom_ready?: number;
    first_paint?: number;
    dns_time?: number;
    connection_time?: number;
}

/**
 * Constantes Clarity
 */
export const CLARITY_CONSTANTS = {
    STORAGE_KEYS: {
        CONSENT: 'clarity-consent',
        USER_ID: 'clarity-user-id',
        SESSION_ID: 'clarity-session-id'
    },

    EVENTS: {
        PAGE_VIEW: 'page_view',
        USER_LOGIN: 'user_login',
        USER_LOGOUT: 'user_logout',
        PURCHASE: 'purchase',
        ERROR: 'error',
        FORM_SUBMIT: 'form_submit'
    },

    CSS_CLASSES: {
        MASK: 'clarity-mask',
        UNMASK: 'clarity-unmask',
        SENSITIVE: 'sensitive-data',
        IMPORTANT: 'important-data'
    }
} as const;
